import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Clock, Loader2 } from 'lucide-react';
import memberApi from '../../lib/memberApi';

export default function PaymentResult() {
  const [params] = useSearchParams();
  const oid = params.get('oid') || '';
  const durum = params.get('durum') || '';
  const [status, setStatus] = useState(durum === 'basarisiz' ? 'failed' : 'checking');

  useEffect(() => {
    let tries = 0;
    let timer;
    const check = async () => {
      tries += 1;
      try {
        const r = await memberApi.get('/member/payments');
        const found = (r.data || []).find(p => p.merchant_oid === oid);
        if (found) {
          if (found.status === 'paid') { setStatus('paid'); return; }
          if (found.status === 'failed' || found.status === 'rejected') { setStatus('failed'); return; }
        }
      } catch { /* ignore */ }
      if (tries < 8 && durum !== 'basarisiz') timer = setTimeout(check, 3000);
      else if (durum !== 'basarisiz') setStatus('pending');
    };
    if (oid && durum !== 'basarisiz') check();
    return () => clearTimeout(timer);
  }, [oid, durum]);

  const views = {
    checking: { icon: <Loader2 className="w-12 h-12 text-[hsl(var(--gold))] animate-spin" />, title: 'Ödemeniz kontrol ediliyor...', desc: 'Lütfen bekleyin, ödeme sonucu doğrulanıyor.' },
    paid: { icon: <CheckCircle2 className="w-12 h-12 text-emerald-500" />, title: 'Ödemeniz Başarılı!', desc: 'Ödemeniz onaylandı. Teşekkür ederiz.' },
    failed: { icon: <XCircle className="w-12 h-12 text-destructive" />, title: 'Ödeme Başarısız', desc: 'Ödeme tamamlanamadı. Lütfen tekrar deneyin veya farklı bir yöntem seçin.' },
    pending: { icon: <Clock className="w-12 h-12 text-amber-500" />, title: 'Ödemeniz İşleniyor', desc: 'Ödemeniz alındı ve işleniyor. Durumu “Ödemelerim” bölümünden takip edebilirsiniz.' },
  };
  const v = views[status] || views.checking;

  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center" data-testid="payment-result-page">
      <div className="flex justify-center mb-5">{v.icon}</div>
      <h1 className="font-heading text-2xl font-semibold mb-2">{v.title}</h1>
      <p className="text-sm text-muted-foreground mb-6">{v.desc}</p>
      {oid && <p className="text-xs text-muted-foreground font-mono mb-8">Ödeme No: {oid}</p>}
      <Link to="/profilim" className="inline-flex items-center px-6 py-2.5 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium hover:bg-[hsl(var(--gold)/0.92)]" data-testid="result-profile-link">
        Profilime Dön
      </Link>
    </div>
  );
}
